import { FC, PropsWithChildren, useCallback, useState } from "react";
import { PromptLibraryItemSource } from "@/modules/promptLibrary/promptLibrary.types";
import { PromptLibraryContext, type PromptToApply } from "@/modules/promptLibrary/usePromptLibraryContext";

export const PromptLibraryContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [subscribers, setSubscribers] = useState<ReadonlyArray<(prompt: string) => void>>([]);
  const [createPromptLibraryModalState, setCreatePromptLibraryModalState] = useState<{
    prompt: string;
    source: PromptLibraryItemSource;
  } | null>(null);
  const [promptToApply, setPromptToApply] = useState<PromptToApply | null>(null);

  const subscribe = useCallback(
    (subscriber: (prompt: string) => void) => {
      setSubscribers(currentSubscribers => [...currentSubscribers, subscriber]);

      return () => setSubscribers(currentSubscribers => currentSubscribers.filter(item => item !== subscriber));
    },

    [setSubscribers],
  );

  const emit = useCallback(
    (prompt: string) => {
      for (const subscriber of subscribers) {
        subscriber(prompt);
      }
    },
    [subscribers],
  );

  const openCreatePromptLibraryModal = (prompt: string, source: PromptLibraryItemSource) => {
    setCreatePromptLibraryModalState({ prompt, source });
  };
  const closeCreatePromptLibraryModal = () => {
    setCreatePromptLibraryModalState(null);
  };

  return (
    <PromptLibraryContext.Provider
      value={{
        closeCreatePromptLibraryModal,
        createPromptLibraryModalState,
        emit,
        openCreatePromptLibraryModal,
        setPromptToApply,
        promptToApply,
        subscribe,
      }}
    >
      {children}
    </PromptLibraryContext.Provider>
  );
};
